/* SHARED formatting for assistant answers. ONE definition, used by BOTH renderers.
 *
 * ⛔ WHY THIS FILE EXISTS. The assistant's answer is painted by two completely separate scripts:
 *
 *     assets/llm-collection-helper.js   collection pages + the homepage finder
 *     assets/llm-meilisearch-search.js  the /search results page
 *
 * They share class names and nothing else. The collection helper formatted the model's light
 * markdown; the search page did `reply.textContent = answer` and shipped customers the raw source —
 * "1. **McKesson Tubular Elastic Retainer Net, Size 4** is ideal for large hands", asterisks and
 * all, on desktop AND mobile (owner, 2026-09-13). The formatter was not broken. It simply was not
 * there.
 *
 * Copying the regex into the second file would have fixed today and drifted by next month, which is
 * the failure this codebase has already paid for elsewhere. So: one function, on window, loaded
 * globally, and both callers use it.
 *
 * ⚠️ ESCAPE FIRST, THEN ADD MARKUP. The input is model output and must never be trusted. Every
 * `<`, `&` and quote is escaped before a single tag is introduced, so the only HTML that can reach
 * the page is the handful of tags built here.
 */
(function () {
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* The model replies in light markdown. Rather than pull in a parser, handle the few things it
     actually emits: bold, bullets, and numbered items. */
  function format(t) {
    var text = String(t == null ? '' : t)
      /* The model sometimes emits an announcement ("Let me find a few options for you.") and then
         the real answer as a second chunk. Drop the announcement: it tells the customer nothing and
         it reads as a stall. */
      .replace(/^\s*(?:sure[,!.]?\s*)?(?:let me|i'?ll|i am going to|i will)\s+(?:find|look|search|check)[^.!?]*[.!?]\s*/i, '')
      /* Those two chunks arrive concatenated with no separator, producing "…for you.For your
         mother…". Restore the space after sentence punctuation. */
      .replace(/([.!?])([A-Z])/g, '$1 $2')
      .trim();

    return esc(text)
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
      /* A numbered item gets its own block so the list reads as a list instead of one dense
         paragraph — the readability complaint on mobile, where a five-item answer ran together into
         a wall of text. The number is kept (it matches the numbered product cards below). */
      .replace(/^\s*(\d+)\.\s+/gm, '<span class="llm-cah__li"><span class="llm-cah__li-n">$1.</span> ')
      .replace(/(<span class="llm-cah__li">[\s\S]*?)(?=<span class="llm-cah__li">|$)/g, function (m) {
        return m.replace(/\s*$/, '') + '</span>';
      })
      .replace(/^\s*[-*]\s+/gm, '• ');
  }

  window.LLM_ANSWER = { esc: esc, format: format };
})();
